import { LightshowState } from '../lightshow-state';
import { FlashTypes } from '../operation-types';

export abstract class LightShowOperation {

  public color: string;
  public position: number;
  public duration: number;
  public audioUrl?: string;
  public imageUrl?: string;
  public sectionList?: string[];
  public timelineColor?: string;
  public flashType: FlashTypes;
  public operationFlashOn: boolean;
  public uniqueId: string;
  public show: boolean;
  public hover: boolean;
  public abstract tick(state: LightshowState): void; // executed on each cycle if active
  public abstract end(state: LightshowState): void; // executed on each cycle if completed
  public abstract wait(state: LightshowState): void; // executed on each cycle if pending

  /**
   * Some operations add preload json objects at specific intervals and need to know about previous operations to space the position of preload items.
   * TODO: check if this is really needed (if the mobile app works ok even if multiple preload operations at the same position, the allOperations param can be removed)
   * */
  public abstract toJson(allOperations: LightShowOperation[]): any[];
}
